import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import bhaktiSangeetManagementService from "../../services/BhaktiSangeetManagement";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const BhaktiSangeet = () => {
  return (
    <ContentManagement
      service={bhaktiSangeetManagementService}
      pageSize={10}
      sidebarItemLayout="horizontal"
      // use the podcast title as the slug
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.AUDIO}
    />
  );
};

export default BhaktiSangeet;